<template>
  <div class="hisVideo">
    <div
      v-for="(item, index) in hisArr"
      :key="index"
      class="flex_r"
      @click="goInfo(item.id)"
    >
      <div class="timeLine f20 fgray line28 flex0">
        <p class="date fw600">{{item.time.split(' ')[0]}}</p>
        <p class="time margint4">{{item.time.split(' ')[1]}}</p>
      </div>
      <div class="triangle flex0"></div>
      <div class="content flex_r flex1">
        <div class="video">
          <img :src="item.img" class="cover" alt="" />
        </div>
        <div class="msg">
          <div  class="title cursor f20 line28 fw600 ellipsis">{{ item.title }}</div>
          <div class="articleTag f16 line24 margint12">
            <span>{{ item.job_txt }}</span
            ><span>{{ item.topic_txt }}</span>
          </div>
          <div class="line24 f18 flex_r_between fgray margint12">
            <div class="flex_r">
              <svgIcon name="location" class="marginr4" />
              <span>{{ item.province_txt + item.city_txt }}</span>
            </div>
          </div>
          <div class="author flex_r margint24">
            <img v-if="item.logo" :src="item.logo" alt="" />
            <div class="name">{{ item.uname }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    hisArr: {
      type: Array,
      default: () => [],
    },
  },
  name: "hisVideo",
  data() {
    return {};
  },
  methods: {
    goInfo(id) {
      this.$router.push({
        name: "info",
        params: {
          infoid: id,
        },
      });
    },
  },
};
</script>
<style lang='less' scoped>
.hisVideo {
  .timeLine {
    padding: 0 20px 0 27px;
  }
  .triangle {
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-right: 8px solid #e6e6e6;
  }
  .content {
    padding: 0 16px 40px;
    border-left: #e6e6e6 2px solid;
    .video {
      width: 284px;
      height: 160px;
      .cover {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
      }
    }
    .msg {
      margin-left: 16px;
      img {
        width: 32px;
        height: 32px;
        margin-right: 8px;
        border-radius: 50%;
      }
      .name {
        color: rgba(87, 75, 75, 1);
        font-size: 18px;
      }
    }
  }
  .articleTag {
    span {
      margin-right: 4px;
      padding: 0 6px;
      height: 24px;
      border-radius: 4px;
      &:nth-child(1) {
        color: #ffddab;
        background: #ad2729;
      }
      &:nth-child(2) {
        color: #958f8f;
        border: 1px solid #958f8f;
      }
    }
  }
}
</style>